import { useQuery } from "react-query";
import { axios } from "../../lib/axios";
import { onError } from "./onError";

export function useQuestionQuery({ orgId, onSuccess }) {
  return useQuery(
    ["questions-list", orgId],    
    async () => {
      const res = await axios.get(`/question?orgId=${orgId}`);
      return res.data;                      
    },
    {
      enabled: !!orgId,
      keepPreviousData: true,
      onSuccess,
      onError,
    }
  );
}
